import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { DeadlineFilter } from "./DeadlineFilter";
import { useFilters } from "hooks/useFilter";
import { NewCompliance } from "./Compliance/NewCompliance";

export const DeadlineAlarm = () => {
  const { values: filterValues, updateFilter } = useFilters({
    initialValue: {
      STATUS: [] as string[],
      ENTITY: [] as string[],
    },
  });
  return (
    <DashboardLayout
      header={
        <Header
          title="Deadlines"
          v2
          bottom={
            <div className="t-my-4">
              <DeadlineFilter
                values={filterValues}
                updateFilter={updateFilter}
              />
            </div>
          }
        />
      }
    >
      <section className="t-flex t-flex-col t-h-full">
        <NewCompliance filterValue={filterValues} />
      </section>
    </DashboardLayout>
  );
};
